import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../../services/api';
import utils from '../../../../services/utils';

import './RequestPassword.css';

class RequestPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            errorMessage: '',
            showSuccess: false
        };

        this.handleUserInput = this.handleUserInput.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    handleUserInput(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value});
    }

    submitForm() {
        let validEmail = utils.validateEmail(this.state.email);

        if (validEmail) {
            api.requestPassword(this.state.email)
            .then((res) => {
                let response = res.data;

                if (response.success) {
                    this.setState({
                        showSuccess: true,
                        errorMessage: ''
                    });
                } else {
                    console.error(res);
                    this.setState({
                        errorMessage: `It seems there was an error somewhere on our end, please contact us at contact@kylxx.co with details of your problem.`,
                        showSuccess: false
                    });
                }
            });
        }

        else {
            this.setState({
                errorMessage: 'Please enter a valid email address.',
                showSuccess: false
            });
        }
    }

    render() {
        return (
            <div className="request-password-step">
                <div className="request-password-step-text">
                    <hr />
                    <p className="request-password-step-header"> Please enter your email to request a password to our user creation portal.</p>
                    <p style={{marginTop: 15}} className="request-password-step-header">Already approved? Start onboarding <Link className="noselect" to='/onboard'>here</Link>.</p>
                </div>

                <div className="request-password-form-div">
                    <form onSubmit={e => { e.preventDefault(); }}>
                        <input
                            onChange={(event) => this.handleUserInput(event)}
                            name="email"
                            value={this.state.email}
                            className="request-password-step-input"
                            type="text"
                            placeholder="Email address"
                        />

                        <button onClick={this.submitForm} className="request-password-submit-btn">
                            <i className="ion ion-android-arrow-forward" />
                        </button>
                    </form>
                </div>

                <p className={"auth-err form-error" + (this.state.errorMessage.length > 0 ? '' : ' hidden-error')}>
                    {this.state.errorMessage}
                </p>

                <p className={"success-message " + (this.state.showSuccess ? '' : ' hidden')}>
                    Thanks for submitting to Veles! You should receive an email detailing further instructions.
                </p>
            </div>
        );
    };
}

export default RequestPassword;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/RequestPassword/RequestPassword.js